
/**
 * **チェーンの処理**（Issue #537）。そのリンクの効果が今処理されている。
 *
 * 開く: `chain_solving`。画面の中央に「RESOLVE」と光。
 * あわせて**処理中の札を置く**（`processing`）—— 帯が終わっても残り、`chain_end` が消す。
 */
const COLOR = '#ffd76a';

/** 状況ごとのファイル（`../effects/chain_solving_<variant>_effect.js`）が共有する組み立て（Issue #628。arcade はどの状況も同じ絵） */
export const spec = {
  label: 'チェーンの処理',
  color: COLOR,

  /** **処理中の札を置く**（帯が終わっても残る。消すのは `chain_end`） */
  places({ payload }) {
    return payload?.uid ? [{ mark: 'processing', key: payload.uid, data: { at: { card: payload.uid } } }] : [];
  },

  /**
   * **このイベントは `{ chain: n }` だけ**（どのカードかを持っていない）。
   * **そのチェーンを組んだ `chaining` から引く**（窓はターン。同じチェーンの番号で突き合わせる）。
   */
  opens({ payload, history }) {
    const from = history.last('chaining', { within: 'turn', filter: (p) => p.chain === payload.chain });
    const card = from?.payload ?? {};
    return { ...payload, uid: card.uid ?? null, code: card.code ?? null, zone: card.zone ?? null, player: card.player ?? 0 };
  },

  layers: [
    {
      id: 'flash',
      label: '光',
      part: 'glow',
      at: { screen: [960, 540] },
      props: { color: COLOR, core: 0.08 },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.5 }, { ms: 260, value: 2.2, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 140, value: 0.7 }, { ms: 620, value: 0 }] },
      },
    },
    {
      id: 'label',
      label: 'RESOLVE',
      part: 'text',
      parent: 'flash',
      props: { text: 'RESOLVE', size: 96, color: '#fff' },
      tf: {
        opacity: { keys: [{ ms: 60, value: 0 }, { ms: 200, value: 1 }, { ms: 540, value: 1 }, { ms: 680, value: 0 }] },
        scale: { keys: [{ ms: 60, value: 0.5 }, { ms: 260, value: 0.46, ease: 'ease_out' }] },
      },
    },
  ],
};
